import React, { useEffect, useMemo, useState } from 'react';
import useOsDark from '../../hooks/useOsDark';

interface ModuleFrameProps {
  path?: string;
}

export const ModuleFrame: React.FC<ModuleFrameProps> = ({ path }) => {
  const src = path || '/';
  const isOsDark = useOsDark();
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(false);
  }, [src]);

  const loadingBackground = useMemo(() => {
    return isOsDark ? '#020a17' : '#f3f6fb';
  }, [isOsDark]);

  return (
    <div className="relative h-full w-full overflow-hidden bg-background">
      <iframe
        src={src}
        title="CanXP Module"
        className="h-full w-full border-0 transition-opacity duration-150"
        style={{
          backgroundColor: loadingBackground,
          opacity: isLoaded ? 1 : 0,
        }}
        onLoad={() => setIsLoaded(true)}
      />

      {!isLoaded && (
        <div
          className="pointer-events-none absolute inset-0"
          style={{ backgroundColor: loadingBackground }}
        />
      )}
    </div>
  );
};

export default ModuleFrame;
